const ServiceHeader = () => {
  return (
    <div className="flex flex-col space-y-5 pt-16 pb-5  sm:w-[60%] lg:w-[50%]">
      <div>
        <h1 className=" text-3xl sm:text-4xl font-bold font-mono">
          Work more easily with everyone
        </h1>
      </div>
      <div>
        <p className=" text-lg font-semibold tracking-wider">
          Stay on the same page and make decisions more quickly by bringing all
          of your work communication into one place.
        </p>
      </div>
    </div>
  );
};

export default ServiceHeader;
